module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search-container"
  }, [_c('div', {
    staticClass: "search-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "date",
      "name": "fromDate"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "trainings"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.onSearch
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_do_search')) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "timed-slots-page"
  }, [_c('div', {
    staticClass: "timed-slots-row"
  }, [_vm._l((_vm.filteredSlots), function(slot, idx) {
    return _c('div', {
      key: slot.slot.id || idx,
      class: _vm.focusedSlotItem === slot.slot.id ? 'timed-slot-card focused' : 'timed-slot-card',
      on: {
        "click": function($event) {
          return _vm.onClickSlotItemFocus(slot.slot)
        }
      }
    }, [_c('div', {
      staticClass: "timed-slot-header"
    }, [_c('div', {
      staticClass: "timed-slot-name"
    }, [_vm._v(_vm._s(slot.slot.name))]), _vm._v(" "), _c('div', {
      staticClass: "capacity"
    }, [_c('span', [_vm._v(_vm._s(_vm.busyCount(slot)) + "/" + _vm._s(slot.slot.capacity))])]), _vm._v(" "), _c('button', {
      staticClass: "btn edit",
      on: {
        "click": function($event) {
          return _vm.onEditTimedSlot(slot)
        }
      }
    }, [_vm._v("\n              ✎ " + _vm._s(_vm.locale.t('label_edit')) + "\n            ")])]), _vm._v(" "), (slot.addingMode) ? _c('div', {
      staticClass: "add-form"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updateTimedSlot.name),
        expression: "updateTimedSlot.name"
      }],
      staticClass: "form-control input",
      attrs: {
        "type": "text",
        "placeholder": _vm.locale.t('label_timed_slot_name')
      },
      domProps: {
        "value": (_vm.updateTimedSlot.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.updateTimedSlot, "name", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.updateTimedSlot.capacity),
        expression: "updateTimedSlot.capacity",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control input",
      attrs: {
        "type": "number",
        "placeholder": _vm.locale.t('label_capacity')
      },
      domProps: {
        "value": (_vm.updateTimedSlot.capacity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.updateTimedSlot, "capacity", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [_c('button', {
      staticClass: "btn save",
      on: {
        "click": function($event) {
          return _vm.editNewTimedSlot(slot)
        }
      }
    }, [_vm._v("\n                💾 " + _vm._s(_vm.locale.t('label_save')) + "\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn cancel",
      on: {
        "click": function($event) {
          return _vm.onCancelEditTimedSlot(slot)
        }
      }
    }, [_vm._v("\n                ✖ " + _vm._s(_vm.locale.t('label_cancel')) + "\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn delete",
      on: {
        "click": function($event) {
          return _vm.onDeleteTimedSlot(slot)
        }
      }
    }, [_vm._v("\n                🗑 " + _vm._s(_vm.locale.t('label_delete')) + "\n              ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "progress-wrap",
      attrs: {
        "title": _vm.capacityTitle(slot)
      }
    }, [_c('div', {
      staticClass: "progress-bar",
      class: _vm.progressColor(slot),
      style: ({
        width: _vm.progressPct(slot) + '%'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "guests-list"
    }, [_vm._l((slot.items), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "guest-row",
        class: _vm.statusClass(item)
      }, [_c('div', {
        staticClass: "guest-name"
      }, [_vm._v("\n                " + _vm._s(item.firstName) + " " + _vm._s(item.lastName) + "\n              ")]), _vm._v(" "), (item.extensionsItems.length) ? _c('div', {
        staticClass: "extensions-timeline compact"
      }, _vm._l((item.extensionsItems), function(ext, i) {
        return _c('div', {
          key: i,
          staticClass: "ext-item"
        }, [_c('div', {
          staticClass: "ext-dot"
        }), _vm._v(" "), _c('div', {
          staticClass: "ext-content"
        }, [_vm._v(_vm._s(_vm.locale.t('label_extended')) + " " + _vm._s(ext) + " min")])])
      }), 0) : _vm._e(), _vm._v(" "), (item.additionalsItems.length) ? _c('div', {
        staticClass: "extensions-timeline compact"
      }, _vm._l((item.additionalsItems), function(ext, i) {
        return _c('div', {
          key: i,
          staticClass: "ext-item"
        }, [_c('div', {
          staticClass: "ext-dot"
        }), _vm._v(" "), _c('div', {
          staticClass: "ext-content"
        }, [_vm._v(_vm._s(_vm.locale.t('label_shop_item')) + ": " + _vm._s(ext.name) + " (" + _vm._s(ext.price) + " " + _vm._s(_vm.locale.t('label_currency')) + ") ")])])
      }), 0) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "guest-times"
      }, [_c('span', {
        staticClass: "time-chip"
      }, [_vm._v(_vm._s(_vm.locale.t('label_start')) + ": " + _vm._s(_vm.fmt(item.startAt)))]), _vm._v(" "), _c('span', {
        staticClass: "time-chip"
      }, [_vm._v(_vm._s(_vm.locale.t('label_end')) + ": " + _vm._s(_vm.fmt(item.plannedEndAt)))]), _vm._v(" "), _c('span', {
        staticClass: "time-chip strong",
        class: _vm.statusClass(item)
      }, [_vm._v("\n                " + _vm._s(_vm.remainingLabel(item)) + "\n              ")])]), _vm._v(" "), _c('div', {
        staticClass: "guest-actions"
      }, [_c('button', {
        staticClass: "btn checkout",
        on: {
          "click": function($event) {
            return _vm.slotCheckOut(item)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.locale.t('label_checkout')) + "\n                ")]), _vm._v(" "), _c('button', {
        staticClass: "btn extend",
        on: {
          "click": function($event) {
            return _vm.onExtend(item, slot)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.locale.t('label_extend')) + "\n                ")]), _vm._v(" "), _c('button', {
        staticClass: "btn extend",
        on: {
          "click": function($event) {
            return _vm.addShopItem(item)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.locale.t('label_add_shop_item')) + "\n                ")])])])
    }), _vm._v(" "), (!slot.items || slot.items.length === 0) ? _c('div', {
      staticClass: "empty"
    }, [_vm._v("\n              " + _vm._s(_vm.locale.t('label_no_active_guests')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "add-card",
      on: {
        "click": function($event) {
          return _vm.addUserToSlotTime(slot)
        }
      }
    }, [_c('div', {
      staticClass: "plus"
    }, [_vm._v("＋")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.locale.t('label_add_user')))])])], 2), _vm._v(" "), (slot.historyItems.length) ? _c('div', {
      staticClass: "tm-divider"
    }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.locale.t('label_finished')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "guests-list section-top"
    }, _vm._l((slot.historyItems), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "guest-row",
        class: _vm.statusClass(item)
      }, [_c('div', {
        staticClass: "guest-name"
      }, [_vm._v("\n                " + _vm._s(item.firstName) + " " + _vm._s(item.lastName) + "\n              ")]), _vm._v(" "), (item.extensionsItems.length) ? _c('div', {
        staticClass: "extensions-timeline compact"
      }, _vm._l((item.extensionsItems), function(ext, i) {
        return _c('div', {
          key: i,
          staticClass: "ext-item"
        }, [_c('div', {
          staticClass: "ext-dot"
        }), _vm._v(" "), _c('div', {
          staticClass: "ext-content"
        }, [_vm._v(_vm._s(_vm.locale.t('label_extended')) + " " + _vm._s(ext) + " min")])])
      }), 0) : _vm._e(), _vm._v(" "), (item.additionalsItems.length) ? _c('div', {
        staticClass: "extensions-timeline compact"
      }, _vm._l((item.additionalsItems), function(ext, i) {
        return _c('div', {
          key: i,
          staticClass: "ext-item"
        }, [_c('div', {
          staticClass: "ext-dot"
        }), _vm._v(" "), _c('div', {
          staticClass: "ext-content"
        }, [_vm._v(_vm._s(_vm.locale.t('label_shop_item')) + ": " + _vm._s(ext.name) + " (" + _vm._s(ext.price) + " " + _vm._s(_vm.locale.t('label_currency')) + ") ")])])
      }), 0) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "guest-times"
      }, [_c('span', {
        staticClass: "time-chip"
      }, [_vm._v(_vm._s(_vm.locale.t('label_start')) + ": " + _vm._s(_vm.fmt(item.startAt)))]), _vm._v(" "), _c('span', {
        staticClass: "time-chip"
      }, [_vm._v(_vm._s(_vm.locale.t('label_end')) + ": " + _vm._s(_vm.fmt(item.plannedEndAt)))]), _vm._v(" "), (item.actualEndAt != null) ? _c('span', {
        staticClass: "time-chip"
      }, [_vm._v(_vm._s(_vm.locale.t('label_ended')) + ": " + _vm._s(_vm.fmt(item.actualEndAt)))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "guest-actions"
      }, [_c('button', {
        staticClass: "btn extend",
        on: {
          "click": function($event) {
            return _vm.addShopItem(item)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.locale.t('label_add_shop_item')) + "\n                ")])])])
    }), 0)])
  }), _vm._v(" "), (!_vm.addingMode) ? _c('button', {
    staticClass: "add-card",
    on: {
      "click": function($event) {
        _vm.addingMode = true
      }
    }
  }, [_c('div', {
    staticClass: "plus"
  }, [_vm._v("＋")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.locale.t('label_add_new_timed_slot')))])]) : _vm._e(), _vm._v(" "), (_vm.addingMode) ? _c('div', {
    staticClass: "add-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTimedSlot.name),
      expression: "newTimedSlot.name"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_timed_slot_name')
    },
    domProps: {
      "value": (_vm.newTimedSlot.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTimedSlot, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newTimedSlot.capacity),
      expression: "newTimedSlot.capacity",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_capacity')
    },
    domProps: {
      "value": (_vm.newTimedSlot.capacity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTimedSlot, "capacity", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn save",
    on: {
      "click": function($event) {
        return _vm.addNewTimedSlot(_vm.slot)
      }
    }
  }, [_vm._v("\n              💾 " + _vm._s(_vm.locale.t('label_save')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn cancel",
    on: {
      "click": function($event) {
        return _vm.cancelAddNewTimedSlot(_vm.slot)
      }
    }
  }, [_vm._v("\n              ✖ " + _vm._s(_vm.locale.t('label_cancel')) + "\n            ")])])]) : _vm._e()], 2)]), _vm._v(" "), _c('choose-user-modal', {
    attrs: {
      "show": _vm.slotToAdd != null
    }
  }), _vm._v(" "), _c('choose-shop-item-modal', {
    attrs: {
      "show": _vm.slotToChooseShopItem != null
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e125a30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimedSlot/TimedSlot.vue
// module id = 748
// module chunks = 0